export const hi = {
  // Navigation
  home: "होम",
  about: "हमारे बारे में",
  tours: "टूर",
  deals: "डील्स",
  testimonials: "ग्राहक समीक्षा",
  blog: "ब्लॉग",
  contact: "संपर्क",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "श्रीलंका में आपका स्वागत है",
  welcomeSubtitle: "हिंद महासागर के मोती की सुंदरता की खोज करें",
  exploreButton: "टूर एक्सप्लोर करें",
  learnMoreButton: "और जानें",
  
  // About page
  aboutTitle: "हमारे बारे में",
  aboutSubtitle: "श्रीलंका में आपका भरोसेमंद यात्रा साथी",
  aboutDescription: "हम श्रीलंका भर में अविस्मरणीय यात्रा अनुभव बनाने में विशेषज्ञ हैं, बेदाग समुद्र तटों से लेकर प्राचीन मंदिरों तक।",
  
  // Tours page
  toursTitle: "हमारे टूर",
  toursSubtitle: "अद्भुत गंतव्यों की खोज करें",
  bookNow: "अभी बुक करें",
  viewDetails: "विवरण देखें",
  
  // Contact page
  contactTitle: "हमसे संपर्क करें",
  contactSubtitle: "हमसे संपर्क करें",
  name: "नाम",
  email: "ईमेल",
  message: "संदेश",
  send: "संदेश भेजें",
  phone: "फोन",
  address: "पता",
  
  // Testimonials
  testimonialsTitle: "हमारे ग्राहक क्या कहते हैं",
  testimonialsSubtitle: "वास्तविक यात्रियों के वास्तविक अनुभव",
  
  // Blog
  blogTitle: "यात्रा ब्लॉग",
  blogSubtitle: "नवीनतम यात्रा कहानियां और सुझाव",
  readMore: "और पढ़ें",
  
  // Common
  loading: "लोड हो रहा है...",
  error: "एक त्रुटि हुई",
  success: "सफलता!",
  close: "बंद करें",
  submit: "जमा करें",
  cancel: "रद्द करें",
  
  // Language selector
  selectLanguage: "भाषा चुनें",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  russian: "Русский",
  chinese: "中文",
  hindi: "हिन्दी",
  arabic: "العربية",
  
  // About Us Page
  whyChooseTitle: "श्री यात्रा ट्रैवल्स क्यों चुनें?",
  whyChooseSubtitle: "हम असाधारण सेवा और व्यक्तिगत पैकेजों के साथ आपको सर्वोत्तम यात्रा अनुभव प्रदान करने के लिए प्रतिबद्ध हैं।",
  personalizedTitle: "व्यक्तिगत यात्रा योजना",
  personalizedDesc: "हम आपकी अनूठी आवश्यकताओं के अनुसार प्रत्येक यात्रा को अनुकूलित करते हैं, एक-एक-एक यात्रा अनुभव सुनिश्चित करते हैं।",
  customerSupportTitle: "24/7 ग्राहक सहायता",
  customerSupportDesc: "हमारे समर्पित यात्रा विशेषज्ञ किसी भी प्रश्न में आपकी सहायता के लिए चौबीसों घंटे उपलब्ध हैं।",
  destinationsTitle: "हाथ से चुने गए गंतव्य",
  destinationsDesc: "अविस्मरणीय अनुभव प्रदान करने के लिए सावधानी से चुने गए सर्वोत्तम गंतव्यों का अन्वेषण करें।",
  priceGuaranteeTitle: "सर्वोत्तम मूल्य गारंटी",
  priceGuaranteeDesc: "हम आपके यात्रा अनुभव की गुणवत्ता से समझौता किए बिना प्रतिस्पर्धी मूल्य प्रदान करते हैं।",
  luxuryTitle: "लक्जरी और आराम",
  luxuryDesc: "अंतिम आराम के लिए शानदार आवास और निर्बाध यात्रा व्यवस्था का आनंद लें।",
  guidesTitle: "विशेषज्ञ टूर गाइड",
  guidesDesc: "हमारे ज्ञानवान और मित्रवत गाइड सुनिश्चित करते हैं कि आप अपनी यात्रा से अधिकतम लाभ उठाएं।",
  
  // Contact Page
  getInTouchTitle: "श्री यात्रा ट्रैवल्स से संपर्क करें",
  loveToHearTitle: "हम आपसे सुनना चाहेंगे",
  loveToHearDesc: "चाहे आपके पास हमारे टूर, मूल्य निर्धारण, या किसी अन्य चीज़ के बारे में कोई प्रश्न हो, हमारी टीम आपके सभी प्रश्नों का उत्तर देने के लिए तैयार है।",
  office: "कार्यालय",
  phone: "फोन",
  support: "सहायता",
  email: "ईमेल",
  officeAddress: "Watabage Junction, Panadura, Sri Lanka",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "हमें एक संदेश भेजें",
  contactFormDesc: "नीचे दिया गया फॉर्म भरें और हम जल्द से जल्द आपसे संपर्क करेंगे।",
  namePlaceholder: "आपका नाम",
  emailPlaceholder: "आपका ईमेल",
  phonePlaceholder: "आपका फोन नंबर",
  messagePlaceholder: "आपका संदेश",
  submitButton: "संदेश भेजें",
  submitting: "भेजा जा रहा है...",
  messageSent: "संदेश सफलतापूर्वक भेजा गया!",
  messageError: "संदेश भेजने में विफल। कृपया पुनः प्रयास करें।",
  
  // Testimonials Page
  customerReviewsTitle: "हमारे ग्राहक क्या कहते हैं",
  customerReviewsSubtitle: "हमारे साथ श्रीलंका का अन्वेषण करने वाले वास्तविक यात्रियों के वास्तविक अनुभव",
  
  // Blog Page
  travelBlogTitle: "यात्रा ब्लॉग",
  travelBlogSubtitle: "श्रीलंका में हमारे रोमांच से नवीनतम यात्रा कहानियां, सुझाव और अंतर्दृष्टि",
  
  // Tours Page
  ourToursTitle: "हमारे टूर",
  ourToursSubtitle: "अद्भुत गंतव्यों और अविस्मरणीय अनुभवों की खोज करें",
  
  // Deals Page
  specialDealsTitle: "विशेष डील्स",
  specialDealsSubtitle: "हमारे सर्वोत्तम टूर पर विशेष प्रस्ताव और छूट",
  
  // Tour Content
  culturalTourTitle: "श्रीलंका सांस्कृतिक टूर",
  culturalTourDesc: "इस सांस्कृतिक टूर में श्रीलंका की समृद्ध विरासत और ऐतिहासिक स्थलों का अनुभव करें।",
  wildlifeTourTitle: "वन्यजीव सफारी रोमांच",
  wildlifeTourDesc: "श्रीलंका के प्रसिद्ध वन्यजीव पार्कों का अन्वेषण करें और उनके प्राकृतिक आवास में विदेशी जानवरों को देखें।",
  beachTourTitle: "समुद्र तट छुट्टी",
  beachTourDesc: "स्फटिक साफ पानी और सुनहरी रेत के साथ श्रीलंका के सबसे सुंदर समुद्र तटों पर आराम करें।",
  hillCountryTourTitle: "पहाड़ी देश रोमांच",
  hillCountryTourDesc: "श्रीलंका के पहाड़ों, झरनों और चाय बागानों की मनोरम सुंदरता की खोज करें।",
  honeymoonTourTitle: "लक्जरी हनीमून पैकेज",
  honeymoonTourDesc: "श्रीलंका के सर्वोत्तम रिसॉर्ट्स में रोमांटिक और शानदार हनीमून अनुभव का आनंद लें।",
  adventureTourTitle: "रोमांच और ट्रेकिंग टूर",
  adventureTourDesc: "श्रीलंका में रोमांचक ट्रेकिंग रोमांच और बाहरी गतिविधियों में शामिल हों।",
  
  // Deal Content
  exclusiveHoneymoonTitle: "विशेष श्रीलंका हनीमून पैकेज",
  exclusiveHoneymoonDesc: "रोमांटिक गेटअवे, समुद्र तट रिसॉर्ट्स और सांस्कृतिक अनुभवों के साथ शानदार हनीमून का आनंद लें।",
  adventureWildlifeTitle: "रोमांच और वन्यजीव टूर",
  adventureWildlifeDesc: "रोमांचक सफारी और प्रकृति अभियानों के साथ श्रीलंका के जंगल का अन्वेषण करें।",
  luxuryBeachTitle: "लक्जरी समुद्र तट छुट्टी",
  luxuryBeachDesc: "सर्वोत्तम समुद्र तटों पर आराम करें, जल खेलों का आनंद लें और शीर्ष स्तरीय आतिथ्य का अनुभव करें।",
  culturalHeritageTitle: "सांस्कृतिक विरासत टूर",
  culturalHeritageDesc: "श्रीलंका के यूनेस्को विरासत स्थलों, प्राचीन मंदिरों और जीवंत शहरों का दौरा करें।",
  budgetFamilyTitle: "बजट परिवार छुट्टी",
  budgetFamilyDesc: "सभी उम्र के लिए रोमांचक गतिविधियों के साथ एक किफायती परिवार-अनुकूल पैकेज।",
  ultimateAdventureTitle: "अंतिम रोमांच टूर",
  ultimateAdventureDesc: "श्रीलंका के आश्चर्यजनक परिदृश्यों में ट्रेकिंग, राफ्टिंग और रोमांच खेल।",
  
  // Blog Content
  exploringBeautyTitle: "श्रीलंका की सुंदरता का अन्वेषण",
  exploringBeautyExcerpt: "इस व्यापक यात्रा गाइड में श्रीलंका के लुभावने परिदृश्य, समृद्ध इतिहास और सांस्कृतिक चमत्कारों की खोज करें।",
  bestBeachesTitle: "श्रीलंका के सर्वोत्तम समुद्र तट",
  bestBeachesExcerpt: "सुनहरी रेत के समुद्र तटों से लेकर आश्चर्यजनक फ़िरोज़ा पानी तक, एक सही गेटअवे के लिए श्रीलंका के सर्वोत्तम समुद्र तट गंतव्यों का अन्वेषण करें।",
  wildlifeSafariTitle: "वन्यजीव सफारी रोमांच",
  wildlifeSafariExcerpt: "श्रीलंका के प्रसिद्ध राष्ट्रीय उद्यानों में हाथी, तेंदुए और विदेशी पक्षियों को देखने के रोमांच का अनुभव करें।",
  
  // Testimonial Content
  johnReview: "श्रीलंका की हमारी यात्रा बिल्कुल शानदार थी! योजना और संगठन सही थे, और हमें पूरी यात्रा में अच्छी देखभाल महसूस हुई। श्री यात्रा ट्रैवल्स की दृढ़ता से सिफारिश करते हैं!",
  emmaReview: "वास्तव में एक अविस्मरणीय अनुभव! सुंदर समुद्र तटों से लेकर आश्चर्यजनक सांस्कृतिक स्थलों तक, सब कुछ सही तरीके से योजनाबद्ध था। वापस जाने का इंतजार नहीं कर सकते!",
  carlosReview: "मैंने जिसके साथ कभी बुक किया है वह सबसे अच्छी ट्रैवल एजेंसी! सब कुछ अच्छी तरह से संगठित था, और गाइड ज्ञानवान और मित्रवत थे। एक अविश्वसनीय अनुभव के लिए धन्यवाद!",
  sophiaReview: "एक निर्बाध और अविस्मरणीय यात्रा! टीम पेशेवर थी, और यात्रा कार्यक्रम अच्छी तरह से सोचा गया था। श्रीलंका जाने वाले किसी भी व्यक्ति को श्री यात्रा ट्रैवल्स की दृढ़ता से सिफारिश करते हैं।",
  
  // Common Labels
  activities: "गतिविधियां",
  duration: "अवधि",
  price: "मूल्य",
  workingHours: "कार्य समय",
  workingHoursText: "सोमवार – शुक्रवार: सुबह 9:00 – शाम 6:00",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "श्रीलंका के मुख्य आकर्षण",
  fiveDayHighlightsSubtitle: "मुख्य आकर्षण: कटुनायके, सिगिरिया, कैंडी, एला, गाले। श्रीलंका के अवश्य देखने योग्य गंतव्यों के माध्यम से एक कॉम्पैक्ट यात्रा।",
  bookNow: "अभी बुक करें",
  
  // Katunayake
  day1Title: "आगमन",
  katunayakeTitle: "कटुनायके",
  katunayakeStay: "कटुनायके के पास आरामदायक रहना",
  katunayakeActivities: "गतिविधियां",
  katunayakeArrival: "बंदरनायके अंतर्राष्ट्रीय हवाई अड्डे पर आगमन",
  katunayakeMeetGreet: "मिलना और अभिवादन, पास के रहने की जगह पर स्थानांतरण",
  katunayakeNegombo: "नेगोम्बो समुद्र तट का वैकल्पिक दौरा (समय की अनुमति हो तो)",
  katunayakeRest: "उड़ान से आराम और रिकवरी",
  katunayakeLocation: "कटुनायके - बंदरनायके अंतर्राष्ट्रीय हवाई अड्डा",
  katunayakeDescription: "हवाई अड्डे के पास आरामदायक पहली रात के साथ अपने श्रीलंका मुख्य आकर्षण शुरू करें।",
  
  // Sigiriya
  day2Title: "सिगिरिया",
  sigiriyaTitle: "सिगिरिया",
  sigiriyaStay: "सिगिरिया में गेस्टहाउस",
  sigiriyaTransfer: "सिगिरिया में स्थानांतरण",
  sigiriyaClimb: "सिगिरिया रॉक फोर्ट्रेस पर चढ़ाई",
  sigiriyaExplore: "जल उद्यान और भित्ति चित्रों का अन्वेषण",
  sigiriyaVillage: "गांव का अनुभव या साइकिल की सवारी (वैकल्पिक)",
  sigiriyaLocation: "सिगिरिया रॉक फोर्ट्रेस",
  sigiriyaDescription: "विस्तृत दृश्यों के साथ प्रतिष्ठित यूनेस्को विश्व विरासत स्थल।",
  
  // Kandy
  day3Title: "कैंडी",
  kandyTitle: "कैंडी",
  kandyStay: "कैंडी में होटल",
  kandyTransfer: "कैंडी में स्थानांतरण",
  kandyTemple: "पवित्र दांत अवशेष मंदिर",
  kandyGardens: "रॉयल बॉटनिकल गार्डन, पेराडेनिया",
  kandyLake: "कैंडी झील की सैर और स्थानीय बाजार",
  kandyLocation: "पवित्र दांत अवशेष मंदिर, कैंडी",
  kandyDescription: "पवित्र विरासत और हरे-भरे बगीचों के साथ सांस्कृतिक राजधानी।",
  
  // Ella
  day4Title: "एला",
  ellaTitle: "एला",
  ellaStay: "एला में आरामदायक रहना",
  ellaTrain: "एला के लिए मनोरम ट्रेन यात्रा",
  ellaPeak: "लिटिल एडम्स पीक हाइक",
  ellaBridge: "नाइन आर्चेस ब्रिज व्यूपॉइंट",
  ellaExplore: "शहर में चाय देश के वाइब्स का अन्वेषण",
  ellaLocation: "एला के पास मनोरम ट्रेन",
  ellaDescription: "आश्चर्यजनक पहाड़ी दृश्यों के साथ ठंडी जलवायु का पहाड़ी रिफ्यूज।",
  
  // Galle
  day5Title: "गाले",
  galleTitle: "गाले",
  galleStay: "गाले में होटल (या देर से प्रस्थान)",
  galleTransfer: "गाले में स्थानांतरण",
  galleFort: "यूनेस्को सूचीबद्ध गाले किले का अन्वेषण",
  galleLighthouse: "लाइटहाउस और किले की दीवारों की सैर",
  galleCafes: "कैफे, बुटीक और समुद्र तट दृश्य",
  galleContinue: "हवाई अड्डे के लिए जारी रखें या समुद्र तट रहने का विस्तार करें",
  galleLocation: "गाले किले की दीवारें और लाइटहाउस",
  galleDescription: "अपने मुख्य आकर्षणों को समाप्त करने के लिए ऐतिहासिक तटीय आकर्षण",
  
  // Colombo Tour
  threeDayColomboTitle: "कोलंबो यात्रा - श्रीलंका",
  threeDayColomboSubtitle: "लक्जरी होटल, सांस्कृतिक दौरे, खरीदारी और समुद्र के किनारे आराम के साथ कोलंबो के सर्वोत्तम का अनुभव करें।",
  
  // Colombo
  dayOneTitle: "आगमन",
  dayTwoTitle: "शहर दौरा", 
  dayThreeTitle: "प्रस्थान",
  
  // Day One Activities
  colomboArrival: "बंदरनायके अंतर्राष्ट्रीय हवाई अड्डे पर आगमन",
  colomboTransfer: "होटल में स्थानांतरण और चेक-इन",
  colomboFort: "कोलंबो किले क्षेत्र का अन्वेषण – औपनिवेशिक इमारतें, बाजार और खरीदारी",
  colomboDinner: "होटल रेस्तरां में रात का खाना और रात भर रहना।",
  
  // Day Two Activities
  colomboBreakfast: "होटल में नाश्ता",
  colomboTemple: "गंगारामाया मंदिर और संग्रहालय का दौरा",
  colomboLunch: "स्थानीय रेस्तरां में दोपहर का भोजन",
  colomboMuseum: "राष्ट्रीय संग्रहालय और विहारमहादेवी पार्क का दोपहर का दौरा",
  colomboOvernight: "रात का खाना और रात भर रहना।",
  
  // Day Three Activities
  colomboRelax: "गाले फेस ग्रीन में आराम करें और समुद्र को देखें",
  colomboShopping: "ओडेल या बेयरफुट गैलरी में खरीदारी",
  colomboPrepare: "प्रस्थान की तैयारी",
  colomboCheckout: "चेक-आउट और हवाई अड्डे में स्थानांतरण।",
  
  // Hotels
  cinnamonGrand: "सिनामन ग्रैंड कोलंबो",
  shangriLa: "शांगरी-ला कोलंबो",
  kingsbury: "द किंग्सबरी कोलंबो",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "बजट पैक (श्रीलंका के मुख्य आकर्षण)",
  fiveDayBudgetPackSubtitle: "मुख्य आकर्षण",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "बजट",
  fiveDayBudgetPackHighlights: "मुख्य आकर्षण",
  fiveDayBudgetPackCulture: "संस्कृति",
  fiveDayBudgetPackHistory: "इतिहास",
  fiveDayBudgetPackNature: "प्रकृति",
  fiveDayBudgetPackPrice: "प्रति व्यक्ति US $650 से",
  moreInformation: "अधिक जानकारी ➜",
  
  threeDayColomboCityTitle: "कोलंबो सिटी अनुभव",
  threeDayColomboCitySubtitle: "शहर दौरा",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "शहर दौरा",
  threeDayColomboCityCulture: "संस्कृति",
  threeDayColomboCityShopping: "खरीदारी",
  threeDayColomboCityLuxury: "लक्जरी होटल",
  threeDayColomboCitySightseeing: "दर्शनीय स्थल",
  threeDayColomboCityPrice: "प्रति व्यक्ति US $350 से",
  
  familyTripTitle: "श्रीलंका में परिवार यात्रा",
  familyTripSubtitle: "परिवार पैकेज",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "वन्यजीव",
  familyTripNature: "प्रकृति",
  familyTripCulture: "संस्कृति",
  familyTripHistory: "इतिहास",
  familyTripPrice: "प्रति व्यक्ति US $850 से",
  
  bestOfSriLankaTitle: "श्रीलंका का सर्वोत्तम",
  bestOfSriLankaSubtitle: "व्यापक",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "समुद्र तट",
  bestOfSriLankaWildlife: "वन्यजीव",
  bestOfSriLankaNature: "प्रकृति",
  bestOfSriLankaCulture: "संस्कृति",
  bestOfSriLankaPrice: "प्रति व्यक्ति US $1250 से",
  
  romanticGetawayTitle: "श्रीलंका में रोमांटिक गेटअवे",
  romanticGetawaySubtitle: "रोमांटिक पैकेज",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "प्रकृति",
  romanticGetawayBeach: "समुद्र तट",
  romanticGetawayWildlife: "वन्यजीव",
  romanticGetawayHistory: "इतिहास",
  romanticGetawayPrice: "प्रति व्यक्ति US $1700 से",
  
  // Why Choose Us
  whyChooseUsTitle: "हमें क्यों चुनें",
  whyChooseUsSubtitle: "कई लोगों ने हमें अपनी नंबर वन यात्रा गंतव्य प्रबंधन कंपनी के रूप में चुना है, और आप भी निम्नलिखित कारणों से हमें चुनेंगे।",
  
  whyChooseUsReason1: "हम श्रीलंका में शीर्ष गंतव्य प्रबंधन कंपनियों में से एक हैं।",
  whyChooseUsReason2: "हम श्रीलंका में अग्रणी टूर ऑपरेटरों में से एक हैं।",
  whyChooseUsReason3: "हम यात्रियों और यात्रा एजेंटों को एक पूर्ण यात्रा पैकेज प्रदान करते हैं।",
  whyChooseUsReason4: "हमारे पास श्रीलंका पर्यटन के व्यापक ज्ञान के साथ 40 प्रतिनिधियों की एक भावुक और पेशेवर टीम है।",
  whyChooseUsReason5: "हम श्रीलंका में अग्रणी यात्रा एजेंटों में से एक हैं।",
  whyChooseUsReason6: "हम अपने ग्राहकों को कस्टम-मेड और विशेष टूर प्रदान करते हैं।",
  whyChooseUsReason7: "हम श्रीलंका में एक अग्रणी यात्रा एजेंट हैं जो विदेशी गंतव्यों के लिए टूर और छुट्टी पैकेज प्रदान करते हैं।",
  whyChooseUsReason8: "हम अपने ग्राहकों को 24/7 ग्राहक सहायता प्रदान करते हैं।",
  
  readMore: "और पढ़ें",
  
  // How It Works
  howItWorksTitle: "यह कैसे काम करता है?",
  
  // Common UI elements
  days: "दिन",
  from: "से",
  perPerson: "प्रति व्यक्ति",
  
  step1Title: "1. अभी पूछताछ करें",
  step1Time: "5 मिनट",
  step1FillingForm: "वेब फॉर्म भरना",
  step1WebChat: "वेब लाइव चैट",
  step1Email: "ईमेल",
  step1Call: "हमें कॉल करें",
  
  step2Title: "2. यात्रा विशेषज्ञ से जुड़ें",
  step2Time: "30 मिनट",
  step2Discuss: "अपनी आवश्यकताओं पर चर्चा करें",
  step2FreeAdvice: "मुफ्त विशेषज्ञ यात्रा सलाह",
  step2Support: "24/7 सहायता",
  
  step3Title: "3. 3 यात्रा विकल्प प्राप्त करें",
  step3Discuss: "परिवर्तनों पर चर्चा करें",
  step3Finalise: "यात्रा योजना को अंतिम रूप दें",
  step3Pay: "10% भुगतान करें",
  
  step4Title: "4. अपनी यात्रा पुष्टि प्राप्त करें",
  step4FillingForm: "वेब फॉर्म भरना",
  step4Satisfaction: "100% संतुष्टि गारंटी",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "श्रीलंका का पूर्ण सर्किट",
  completeSriLankaSubtitle: "व्यापक",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "व्यापक",
  completeSriLankaHighlights: "मुख्य आकर्षण",
  completeSriLankaCulture: "संस्कृति",
  completeSriLankaHistory: "इतिहास",
  completeSriLankaNature: "प्रकृति",
  completeSriLankaBeach: "समुद्र तट",
  completeSriLankaPrice: "प्रति व्यक्ति US $1850 से",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "श्रीलंका का पूर्ण सर्किट",
  completeSriLankaCircuitSubtitle: "सभी प्रमुख गंतव्यों को कवर करने वाली इस व्यापक यात्रा के साथ श्रीलंका की पूर्ण सुंदरता का अनुभव करें।",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "अनुराधापुर",
  ancientCityStay: "अनुराधापुर में होटल",
  ancientCityTransfer: "अनुराधापुर स्थानांतरण",
  ancientCityExplore: "प्राचीन खंडहर और स्तूपों का अन्वेषण",
  ancientCityTemple: "श्री महा बोधि वृक्ष का दौरा",
  ancientCityMuseum: "पुरातत्व संग्रहालय का दौरा",
  ancientCityLocation: "अनुराधापुर प्राचीन शहर",
  ancientCityDescription: "श्रीलंका की प्राचीन राजधानी और यूनेस्को विश्व धरोहर स्थल की खोज करें।",
  
  // Nuwara Eliya
  day5Title: "नुवारा एलिया",
  nuwaraEliyaTitle: "नुवारा एलिया",
  nuwaraEliyaStay: "नुवारा एलिया में होटल",
  nuwaraEliyaTransfer: "नुवारा एलिया स्थानांतरण",
  nuwaraEliyaTea: "चाय बागान और कारखाना दौरा",
  nuwaraEliyaLake: "ग्रेगरी झील नाव की सवारी",
  nuwaraEliyaExplore: "लिटिल इंग्लैंड का अन्वेषण",
  nuwaraEliyaLocation: "नुवारा एलिया चाय देश",
  nuwaraEliyaDescription: "लिटिल इंग्लैंड के ठंडे मौसम और चाय देश के आकर्षण का अनुभव करें।",
  
  // Ella (Second Day)
  day6Title: "एला",
  day7Title: "एला विस्तारित",
  ellaWaterfall: "रावण झरने का दौरा",
  ellaTea: "चाय बागान दौरा",
  ellaRelax: "आराम करें और पहाड़ी दृश्यों का आनंद लें",
  ellaLocal: "स्थानीय गांव अनुभव",
  ellaDay2Description: "झरनों और चाय देश का अन्वेषण करने के लिए एला में दूसरा दिन।",
  
  // Mirissa
  day8Title: "मिरिसा",
  mirissaTitle: "मिरिसा",
  mirissaStay: "मिरिसा में समुद्र तट रिसॉर्ट",
  mirissaTransfer: "मिरिसा स्थानांतरण",
  mirissaBeach: "मिरिसा समुद्र तट पर आराम करें",
  mirissaWhale: "व्हेल देखने का दौरा (मौसमी)",
  mirissaRelax: "समुद्र तट आराम और सूर्यास्त",
  mirissaLocation: "मिरिसा समुद्र तट",
  mirissaDescription: "सुंदर समुद्र तटों और व्हेल देखने के अवसरों का आनंद लें।",
  
  // Mirissa (Second Day)
  day9Title: "मिरिसा विस्तारित",
  mirissaSnorkel: "स्नॉर्कलिंग और जल खेल",
  mirissaDiving: "स्कूबा डाइविंग (वैकल्पिक)",
  mirissaSunset: "सूर्यास्त समुद्र तट सैर",
  mirissaDay2Description: "जल गतिविधियों और समुद्र तट आराम के लिए मिरिसा में दूसरा दिन।",
  
  // Galle
  day10Title: "गाले",
  
  // Galle (Second Day)
  day11Title: "गाले विस्तारित",
  galleShopping: "गाले किले में खरीदारी",
  galleMuseum: "गाले समुद्री संग्रहालय का दौरा",
  galleBeach: "उनावतुना में समुद्र तट समय",
  galleDining: "किले के रेस्तरां में भोजन",
  galleDay2Description: "ऐतिहासिक किले का और अन्वेषण करने के लिए गाले में दूसरा दिन।",
  
  // Bentota
  day12Title: "बेंटोटा",
  bentotaTitle: "बेंटोटा",
  bentotaStay: "बेंटोटा में रिसॉर्ट",
  bentotaTransfer: "बेंटोटा स्थानांतरण",
  bentotaRiver: "बेंटोटा नदी सफारी",
  bentotaBeach: "समुद्र तट गतिविधियां",
  bentotaSpa: "स्पा और कल्याण उपचार",
  bentotaLocation: "बेंटोटा समुद्र तट रिसॉर्ट",
  bentotaDescription: "नदी गतिविधियों के साथ सुंदर समुद्र तट रिसॉर्ट में आराम करें।",
  
  // Colombo
  day13Title: "कोलंबो",
  colomboTitle: "कोलंबो",
  colomboStay: "कोलंबो में होटल",
  colomboTransfer: "कोलंबो स्थानांतरण",
  colomboFort: "कोलंबो किले का अन्वेषण",
  colomboTemple: "गंगारामाया मंदिर का दौरा",
  colomboShopping: "ओडेल और बेयरफुट में खरीदारी",
  colomboLocation: "कोलंबो शहर",
  colomboDescription: "राजधानी के आकर्षण और खरीदारी का अन्वेषण करें।",
  
  // Departure
  day14Title: "प्रस्थान",
  departureTitle: "प्रस्थान",
  departureStay: "हवाई अड्डा होटल या प्रस्थान",
  departureBreakfast: "अंतिम नाश्ता",
  departureShopping: "अंतिम समय खरीदारी",
  departureTransfer: "हवाई अड्डा स्थानांतरण",
  departureAirport: "बंदरानायके अंतर्राष्ट्रीय हवाई अड्डे से प्रस्थान",
  departureLocation: "बंदरानायके अंतर्राष्ट्रीय हवाई अड्डा",
  departureDescription: "हवाई अड्डा स्थानांतरण और प्रस्थान के साथ अंतिम दिन।",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "वन्यजीव और सांस्कृतिक विरासत यात्रा",
  wildlifeCulturalCircuitSubtitle: "इस व्यापक यात्रा में श्रीलंका के वन्यजीव, प्राचीन शहरों और सांस्कृतिक विरासत का अनुभव करें।",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "उदावलावे",
  udawalaweStay: "उदावलावे में सफारी लॉज",
  udawalaweTransfer: "उदावलावे स्थानांतरण",
  udawalaweSafari: "उदावलावे राष्ट्रीय उद्यान सफारी",
  udawalaweElephants: "हाथी देखना और फोटोग्राफी",
  udawalaweBirds: "पक्षी देखने का दौरा",
  udawalaweLocation: "उदावलावे राष्ट्रीय उद्यान",
  udawalaweDescription: "हाथी, पक्षियों और अन्य जानवरों के साथ उनके प्राकृतिक आवास में श्रीलंका के वन्यजीव का अनुभव करें।",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "एला",
  ellaWildlifeStay: "एला में होटल",
  ellaWildlifeTransfer: "एला स्थानांतरण",
  ellaWildlifeTrain: "एला के लिए सुंदर ट्रेन यात्रा",
  ellaWildlifePeak: "छोटी एडम पीक हाइक",
  ellaWildlifeBridge: "नौ आर्क ब्रिज दृश्य बिंदु",
  ellaWildlifeLocation: "एला हिल स्टेशन",
  ellaWildlifeDescription: "शानदार पहाड़ी दृश्यों और चाय बागानों के साथ सुंदर पहाड़ी देश का अन्वेषण करें।",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "नुवारा एलिया",
  nuwaraEliyaWildlifeStay: "नुवारा एलिया में होटल",
  nuwaraEliyaWildlifeTransfer: "नुवारा एलिया स्थानांतरण",
  nuwaraEliyaWildlifeTea: "चाय बागान और कारखाना दौरा",
  nuwaraEliyaWildlifeLake: "ग्रेगरी झील नाव की सवारी",
  nuwaraEliyaWildlifeExplore: "लिटिल इंग्लैंड का अन्वेषण",
  nuwaraEliyaWildlifeLocation: "नुवारा एलिया चाय देश",
  nuwaraEliyaWildlifeDescription: "लिटिल इंग्लैंड के ठंडे मौसम और चाय देश के आकर्षण का अनुभव करें।",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "कैंडी",
  kandyWildlifeStay: "कैंडी में होटल",
  kandyWildlifeTransfer: "कैंडी स्थानांतरण",
  kandyWildlifeTemple: "पवित्र दांत अवशेष मंदिर",
  kandyWildlifeGardens: "रॉयल बॉटनिकल गार्डन",
  kandyWildlifeLake: "कैंडी झील की सैर",
  kandyWildlifeLocation: "पवित्र दांत अवशेष मंदिर",
  kandyWildlifeDescription: "पवित्र विरासत और हरे-भरे बगीचों के साथ सांस्कृतिक राजधानी।",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "सिगिरिया",
  sigiriyaWildlifeStay: "सिगिरिया में होटल",
  sigiriyaWildlifeTransfer: "सिगिरिया स्थानांतरण",
  sigiriyaWildlifeClimb: "सिगिरिया रॉक फोर्ट्रेस पर चढ़ाई",
  sigiriyaWildlifeExplore: "जल उद्यान और भित्ति चित्रों का अन्वेषण",
  sigiriyaWildlifeVillage: "गांव का अनुभव या साइकिल की सवारी (वैकल्पिक)",
  sigiriyaWildlifeLocation: "सिगिरिया रॉक फोर्ट्रेस",
  sigiriyaWildlifeDescription: "पैनोरमिक दृश्यों के साथ आइकॉनिक यूनेस्को विश्व विरासत स्थल।",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "अनुराधापुरा",
  anuradhapuraWildlifeStay: "अनुराधापुरा में होटल",
  anuradhapuraWildlifeTransfer: "अनुराधापुरा स्थानांतरण",
  anuradhapuraWildlifeExplore: "प्राचीन खंडहरों और स्तूपों का अन्वेषण",
  anuradhapuraWildlifeTemple: "श्री महा बोधि वृक्ष का दौरा",
  anuradhapuraWildlifeMuseum: "पुरातत्व संग्रहालय का दौरा",
  anuradhapuraWildlifeLocation: "अनुराधापुरा प्राचीन शहर",
  anuradhapuraWildlifeDescription: "श्रीलंका की प्राचीन राजधानी और यूनेस्को विश्व विरासत स्थल की खोज करें।",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "पोलोनारुवा",
  polonnaruwaStay: "पोलोनारुवा में होटल",
  polonnaruwaTransfer: "पोलोनारुवा स्थानांतरण",
  polonnaruwaExplore: "प्राचीन खंडहरों का अन्वेषण",
  polonnaruwaGalVihara: "गाल विहारा का दौरा",
  polonnaruwaMuseum: "पोलोनारुवा संग्रहालय का दौरा",
  polonnaruwaLocation: "पोलोनारुवा प्राचीन शहर",
  polonnaruwaDescription: "अच्छी तरह से संरक्षित खंडहरों और मूर्तियों के साथ प्राचीन राजधानी का अन्वेषण करें।",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "त्रिंकोमाली",
  trincomaleeStay: "त्रिंकोमाली में होटल",
  trincomaleeTransfer: "त्रिंकोमाली स्थानांतरण",
  trincomaleeBeach: "नीलावेली बीच पर आराम",
  trincomaleeWhale: "व्हेल देखने का दौरा (मौसमी)",
  trincomaleeFort: "फ्रेडरिक किले का अन्वेषण",
  trincomaleeLocation: "नीलावेली बीच, त्रिंकोमाली",
  trincomaleeDescription: "सुंदर समुद्र तटों और व्हेल देखने के अवसरों का आनंद लें।",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "कोलंबो",
  colomboWildlifeStay: "कोलंबो में होटल",
  colomboWildlifeTransfer: "कोलंबो स्थानांतरण",
  colomboWildlifeFort: "कोलंबो किले का अन्वेषण",
  colomboWildlifeTemple: "गंगारामाया मंदिर का दौरा",
  colomboWildlifeShopping: "ओडेल और बेराफुट गैलरी में खरीदारी",
  colomboWildlifeLocation: "कोलंबो शहर",
  colomboWildlifeDescription: "राजधानी के आकर्षण और खरीदारी का अन्वेषण करें।",
  
  // Wildlife Cultural Tour
  wildlifeCulturalTitle: "वन्यजीव और सांस्कृतिक विरासत यात्रा",
  wildlifeCulturalType: "वन्यजीव और संस्कृति",
  wildlifeCulturalHighlights: "मुख्य आकर्षण",
  wildlifeCulturalWildlife: "वन्यजीव",
  wildlifeCulturalCulture: "संस्कृति",
  wildlifeCulturalHistory: "इतिहास",
  wildlifeCulturalNature: "प्रकृति",
  
  // Hill Country Beach Tour
  hillCountryBeachTitle: "पहाड़ी देश और समुद्र तट यात्रा",
  hillCountryBeachType: "पहाड़ी देश और समुद्र तट",
  hillCountryBeachHighlights: "मुख्य आकर्षण",
  hillCountryBeachNature: "प्रकृति",
  hillCountryBeachBeach: "समुद्र तट",
  hillCountryBeachCulture: "संस्कृति",
  hillCountryBeachAdventure: "रोमांच",
  
  // Cultural Triangle Beach Tour
  culturalTriangleBeachTitle: "सांस्कृतिक त्रिभुज और समुद्र तट यात्रा",
  culturalTriangleBeachType: "सांस्कृतिक त्रिभुज और समुद्र तट",
  culturalTriangleBeachHighlights: "मुख्य आकर्षण",
  culturalTriangleBeachCulture: "संस्कृति",
  culturalTriangleBeachHistory: "इतिहास",
  culturalTriangleBeachBeach: "समुद्र तट",
  culturalTriangleBeachRelaxation: "आराम",
  
  // Package 1
  package1Title: "पैकेज 1 - श्रीलंका",
  package1Duration: "4 रातें 5 दिन",
  package1Charges: "केवल होटल और परिवहन शुल्क",
  package1Hotel: "4 सितारा होटल में बिस्तर, रात का खाना और नाश्ता शामिल",
  package1Price: "दो व्यक्ति प्रति दिन $335",
  package1Day1: "दिन 1",
  package1Day1Activity1: "पिन्नावाला",
  package1Day1Activity2: "कैंडी (कैंडी नृत्य)",
  package1Day2: "दिन 2",
  package1Day2Activity1: "नेल्लिगाला",
  package1Day2Activity2: "कैंडी मंदिर",
  package1Day3: "दिन 3",
  package1Day3Activity1: "गडालदेनिया, अंबक्के",
  package1Day3Activity2: "पेरादेनिया बगीचा",
  package1Day4: "दिन 4",
  package1Day4Activity1: "वैक्स संग्रहालय कैंडी",
  package1Day4Activity2: "रत्न, मसाले और बैटिक खरीदारी",
  package1Activities: "गतिविधियां",
  
  // Package 2
  package2Title: "पैकेज 2 - श्रीलंका",
  package2Duration: "4 रातें 5 दिन",
  package2Charges: "केवल होटल और परिवहन शुल्क",
  package2Hotel: "4 सितारा होटल में बिस्तर, रात का खाना और नाश्ता शामिल",
  package2Price: "दो व्यक्ति प्रति दिन $335",
  package2Day1: "दिन 1",
  package2Day1Activity1: "पिन्नावाला",
  package2Day1Activity2: "कैंडी मंदिर",
  package2Day1Activity3: "कैंडी नृत्य",
  package2Day2: "दिन 2",
  package2Day2Activity1: "रत्न, मसाले और बैटिक खरीदारी",
  package2Day2Activity2: "पेरादेनिया बगीचा",
  package2Day2Activity3: "नेल्लिगाला",
  package2Day3: "दिन 3",
  package2Day3Activity1: "नुवारा एलिया",
  package2Day3Activity2: "ग्रेगरी पार्क",
  package2Day4: "दिन 4",
  package2Day4Activity1: "अंबेवेला फार्म",
  package2Activities: "गतिविधियां",
  
  // Package 3
  package3Title: "पैकेज 3 - श्रीलंका",
  package3Duration: "4 रातें 5 दिन",
  package3Charges: "केवल होटल और परिवहन शुल्क",
  package3Hotel: "4 सितारा होटल में बिस्तर, रात का खाना और नाश्ता शामिल",
  package3Price: "दो व्यक्ति प्रति दिन $335",
  package3Day1: "दिन 1",
  package3Day1Activity1: "पिन्नावाला",
  package3Day1Activity2: "कैंडी मंदिर",
  package3Day1Activity3: "कैंडी नृत्य",
  package3Day2: "दिन 2",
  package3Day2Activity1: "पेरादेनिया बगीचा",
  package3Day2Activity2: "नेल्लिगाला",
  package3Day2Activity3: "रत्न, मसाले और बैटिक खरीदारी",
  package3Day3: "दिन 3",
  package3Day3Activity1: "सिगिरिया",
  package3Day4: "दिन 4",
  package3Day4Activity1: "दंबुला मंदिर",
  package3Day4Activity2: "दंबुला गाँव मंदिर",
  package3Activities: "गतिविधियां",
  
  
  // Package tags
  hotel: "होटल",
  transport: "परिवहन",
  cultural: "सांस्कृतिक",
  shopping: "खरीदारी",
  hillCountry: "पहाड़ी देश",
  teaPlantations: "चाय बागान",
  sigiriya: "सिगिरिया",
  heritageSites: "विरासत स्थल",
  safari: "सफारी",
  wildlife: "वन्यजीव",
  
  // Package titles (short version for cards)
  package1: "पैकेज 1",
  package2: "पैकेज 2",
  package3: "पैकेज 3",

  // Package 4
  package4Title: "Package 4 (Couples) - Sri Lanka",
  package4Duration: "5 nights 6 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Two person per day $335",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Package 4 (Couples)",

  // Package 5
  package5Title: "Package 5 - Sri Lanka",
  package5Duration: "6 nights 7 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Two person per day $335",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Package 5",

};
